module.exports = __webpack_public_path__ + "static/img/Success.e40057ba.png";